function log(error, logger) { if (logger !== null && logger !== void 0 && logger.error) {
    logger.error('Error invoking thunk', { error: error });
} console.error(new Error('An error occurred while invoking thunk', { cause: error })); }
export function applyLogging(thunk) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var thunkAction = thunk.apply(void 0, args);
    return function (a) { try {
        var result = thunkAction(a);
        if (result instanceof Promise) {
            result.catch(function (error) { return log(error, a.context.logger); });
            return result;
        }
    }
    catch (error) {
        log(error, a.context.logger);
        throw error;
    } return undefined; };
}; }
